var map = {
	"./battles.webm": 8277,
	"./blackjack.webm": 2430,
	"./cases.webm": 539,
	"./mines.webm": 774,
	"./roulette.webm": 5916,
	"./towers.webm": 3290,
	"./upgrader.webm": 1398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1571;